import { O } from "@scripts/fp-ts";

import type { ReadonlyBig } from "./bigNumberC";
import { Ord } from "./Ord";

export const isLteBigO = (a: O.Option<Big>, b: O.Option<Big>) => O.getOrd(Ord).compare(a, b) <= 0;

export const formatBig = (
  style: "currency" | "decimal",
  options?: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    showCents?: true;
  }
) => (big: ReadonlyBig): string => {
  const {
    minimumFractionDigits = options?.showCents ? 2 : 0,
    maximumFractionDigits = options?.showCents ? 2 : 0,
  } = options || {};

  // Get the string representation with proper decimal places
  const valueStr = big.toFixed(maximumFractionDigits);

  // Split into integer and decimal parts
  const [integerPart = "0", decimalPart = ""] = valueStr.split(".");

  // Add thousands separators to integer part
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Build the final formatted string
  let result = (style === "currency" ? "$" : "") + formattedInteger;

  if (minimumFractionDigits > 0 || decimalPart) {
    // Pad decimal part if needed
    const paddedDecimal = decimalPart.padEnd(minimumFractionDigits, "0");
    result += "." + paddedDecimal.slice(0, Math.max(minimumFractionDigits, decimalPart.length));
  }

  return result;
};

export const formatBigPercentage = (decimalPlaces: number) => (value: ReadonlyBig) => `${value.toFixed(decimalPlaces)}%`;
